import React from 'react';
import styled from 'styled-components';
import { semanticColors } from '@/common/styles/colorTokens';
import ModalCenter from '@/common/components/modal/ModalCenter';
import { typography } from '@/common/styles/typographyTokens';
import { Button } from '@/common/components/button/Button';

interface ErrorModalProps {
  message: string;
  onClose: () => void;
  isOpen: boolean;
}

/**
 * 에러 메시지를 표시하는 모달 컴포넌트
 * @param message - 표시할 에러 메시지
 * @param onClose - 모달 닫기 함수
 * @param isOpen - 모달 열림/닫힘 상태
 */
const ErrorModal: React.FC<ErrorModalProps> = ({ message, onClose, isOpen }) => {
  const footer = (
    <FooterContainer>
      <Button $size='sm' $variant='fill' onClick={onClose}>확인</Button>
    </FooterContainer>
  );

  return (
    <ModalCenter
      isOpen={isOpen}
      onClose={onClose}
      title="오류"
      maxWidth="400px"
      autoClose={true}
      scrollable={false}
      footer={footer}
    >
      <MessageContainer>
        <p>{message}</p>
      </MessageContainer>
    </ModalCenter>
  );
};

const MessageContainer = styled.div`
  width: 400px;
  height: 100px;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${typography.paragraph.p1.default}
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default ErrorModal;
